
import { useState } from "react";
import { useTranslation } from 'react-i18next';

const SearchBar = () => {
    const { t } = useTranslation();

    const [needsMeetingRoom, setNeedsMeetingRoom] = useState(true);
    const [needsRooms, setNeedsRooms] = useState(false);

    return (
        <div id="search-bar-container">
            <app-meeting-events-search-bar >
                <div className="c-search c-search-events">
                    <form noValidate="" className="c-search__wrapper c-search__wrapper--mod needs-validation ng-untouched ng-pristine ng-valid">
                        <div className="c-search__wrapper--grid">
                            <div ngbdropdown="" className="show-p-static dropdown">
                                <div className="input-group">
                                    <input type="text" hoteldestinofilter="" required="" role="button" ngbdropdowntoggle="" className="dropdown-toggle form-control ng-untouched ng-pristine ng-valid" placeholder="Todos los hoteles y destinos" aria-expanded="false" />
                                    <span className="input-group-icon">
                                        <i className="fa-solid fa-location-dot"></i>
                                    </span>
                                </div>
                                <div ngbdropdownmenu="" className="dropdown-menu c-search__inner c-search__inner-choose">
                                    <div className="c-search__dropdown-content">
                                        <div className="c-search__dropdown-header">
                                            <p className="c-search__dropdown-header-title"> Elige destino </p>
                                            <button type="button" ngbdropdowntoggle="" className="dropdown-toggle btn btn-close" aria-expanded="false">
                                                <span className="visually-hidden">general.close</span>
                                            </button>
                                        </div>
                                        <div className="m-3 mb-0 position-relative d-md-none">
                                            <div className="input-group">
                                                <input type="text" hoteldestinofilter="" required="" role="button" className="form-control ng-untouched ng-pristine ng-valid" placeholder="Todos los hoteles y destinos" />
                                                <span className="input-group-icon">
                                                    <i className="fa-solid fa-location-dot"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="c-search__dropdown-body c-search_list-buscador">


                                        </div>
                                        <div className="c-search__dropdown-body">
                                            <div className="mb-4 mb-md-0 c-search_last-search">
                                                <ul className="mb-4 c-search__hotel-list">
                                                    <li className="mb-3 c-search__hotel-item mb-md-0">
                                                        <strong>ÚLTIMAS BÚSQUEDAS</strong>
                                                    </li>

                                                </ul>
                                                <ul className="mb-4 c-search__hotel-list mb-md-0">
                                                    <li className="mb-3 c-search__hotel-item mb-md-0">
                                                        <strong>ÚLTIMAS VISTAS</strong>
                                                    </li>

                                                </ul>
                                            </div>
                                            <ul className="pb-4 mb-4 c-search__hotel-list mb-md-0 pb-md-0 column-break">
                                                <li className="mb-3 c-search__hotel-item mb-md-0">
                                                    <strong>España</strong>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Barcelona <span>(15)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Benidorm <span>(1)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Costa del Sol <span>(1)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Córdoba <span>(1)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Fuerteventura <span>(5)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Gran Canaria <span>(2)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>La Palma <span>(1)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Lanzarote <span>(5)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Madrid <span>(3)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Mallorca <span>(2)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Málaga <span>(1)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Salou - Cambrils <span>(6)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Sevilla <span>(2)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Tarragona <span>(1)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Tenerife <span>(7)</span>
                                                        </span>
                                                    </a>
                                                </li>

                                            </ul>
                                            <ul className="pb-4 mb-4 c-search__hotel-list mb-md-0 pb-md-0 column-break">
                                                <li className="mb-3 c-search__hotel-item mb-md-0">
                                                    <strong>Europa</strong>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Berlín <span>(1)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Lisboa <span>(2)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Londres <span>(1)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Oporto <span>(1)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>París <span>(1)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Roma <span>(2)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Venecia <span>(1)</span>
                                                        </span>
                                                    </a>
                                                </li>

                                            </ul>
                                            <ul className="pb-4 mb-4 c-search__hotel-list mb-md-0 pb-md-0 column-break">
                                                <li className="mb-3 c-search__hotel-item mb-md-0">
                                                    <strong>Caribe</strong>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Costa Mujeres <span>(1)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Jamaica <span>(2)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Punta Cana <span>(2)</span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span className="o-icon">
                                                            <i className="fa-solid fa-location-dot"></i>
                                                        </span>
                                                        <span>Riviera Maya <span>(3)</span>
                                                        </span>
                                                    </a>
                                                </li>

                                            </ul>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="input-group">
                                <input type="text" className="form-control is-invalid ng-untouched ng-pristine ng-invalid" placeholder="25 asistentes" />
                                <span className="input-group-icon">
                                    <use xlinkHref="#icon-user"></use>
                                </span>
                            </div>
                            <div ngbdropdown="" className="dropdown">
                                <div className="input-group">
                                    <input type="text" readOnly="" role="button" ngbdropdowntoggle="" className="dropdown-toggle form-control ng-untouched ng-pristine ng-valid" placeholder="Todos los tipos de evento" aria-expanded="false" />
                                    <span className="input-group-icon">
                                        <use xlinkHref="#icon-business"></use>
                                    </span>
                                </div>
                                <div ngbdropdownmenu="" className="dropdown-menu c-search__inner w-100">
                                    <div className="c-search__dropdown-content">
                                        <div className="c-search__dropdown-header">
                                            <p className="c-search__dropdown-header-title"> Tipo de evento </p>
                                            <button type="button" ngbdropdowntoggle="" className="dropdown-toggle btn btn-icon" aria-expanded="false">
                                                <span className="visually-hidden">general.close</span>
                                                <span className="c-search__dropdown-header-icon">
                                                    <use xlinkHref="#icon-xmark"></use>
                                                </span>
                                            </button>
                                        </div>
                                        <div className="c-search__dropdown-body">
                                            <ul className="pb-4 mb-4 c-search__hotel-list mb-md-0 pb-md-0">
                                                <li className="c-search__hotel-item">
                                                    <a className="text-md-xs">
                                                        <span>Todos los tipos de evento</span>
                                                    </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a type="button" className="text-md-xs"> Bodas y Celebraciones </a>
                                                </li>
                                                <li className="c-search__hotel-item">
                                                    <a type="button" className="text-md-xs"> Reuniones y Eventos </a>
                                                </li>

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="c-search__wrapper--radios">
                                <div className="gap-3 d-flex align-items-center">
                                    <p>¿Necesitas salas de reuniones?</p>
                                    <div className="form-check form-check-inline">
                                        <input type="radio" name="salasReuniones" className="form-check-input ng-untouched ng-pristine ng-valid" />
                                        <label htmlFor="salasReuniones1" className="form-check-label"> Sí </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input type="radio" name="salasReuniones" className="form-check-input ng-untouched ng-pristine ng-valid" />
                                        <label htmlFor="salasReuniones2" className="form-check-label"> No </label>
                                    </div>
                                </div>
                                <div className="gap-3 d-flex align-items-center">
                                    <p>¿Necesitas habitaciones?</p>
                                    <div className="form-check form-check-inline">
                                        <input type="radio" name="habitaciones" className="form-check-input ng-untouched ng-pristine ng-valid" />
                                        <label htmlFor="habitaciones1" className="form-check-label"> Sí </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input type="radio" name="habitaciones" className="form-check-input ng-untouched ng-pristine ng-valid" />
                                        <label htmlFor="habitaciones2" className="form-check-label"> No </label>
                                    </div>
                                </div>
                            </div>
                            <button type="button" className="btn btn-primary" disabled="">BUSCAR</button>
                        </div>
                    </form>
                </div>
            </app-meeting-events-search-bar>
        </div>
    );
}
export default SearchBar;
